import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';

import { USER_TYPE, USER_TYPE_META } from '../../constants/copy.js';
import SelectableCard from './SelectableCard';

/** Owner is not invitable: the builder offers Member and Admin only. */
const OPTIONS = [
  { value: USER_TYPE.MEMBER, descriptionKey: 'invite.people.memberDescription' },
  { value: USER_TYPE.ADMIN, descriptionKey: 'invite.people.adminDescription' },
];

/**
 * User type radio cards of the People step.
 *
 * @param {object} props
 * @param {string} props.value Selected `USER_TYPE`.
 * @param {(userType: string) => void} props.onChange
 */
function UserTypeCards({ value, onChange }) {
  const { t } = useTranslation('people-access');

  return (
    <div className="flex flex-col gap-2">
      <div>
        <h2 className="m-0 text-sm font-medium text-content-secondary">
          {t('invite.people.userTypeLabel')}
        </h2>
        <p className="m-0 text-xs text-content-muted">{t('invite.people.userTypeHelper')}</p>
      </div>
      <div role="radiogroup" className="grid grid-cols-1 gap-3 md:grid-cols-2">
        {OPTIONS.map((option) => (
          <SelectableCard
            key={option.value}
            type="radio"
            value={option.value}
            selected={value === option.value}
            ariaLabel={t(USER_TYPE_META[option.value].labelKey)}
            onSelect={onChange}
          >
            <div className="text-sm font-semibold text-content">
              {t(USER_TYPE_META[option.value].labelKey)}
            </div>
            <p className="m-0 mt-1 text-xs text-content-muted">{t(option.descriptionKey)}</p>
          </SelectableCard>
        ))}
      </div>
    </div>
  );
}

export default memo(UserTypeCards);
